// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3vLvX","title":"Header_title__6ipTn","side":"Header_side__2F3hQ"};